export const environment = {
  production: false,
  apiUrl:  'https://portal.api.maeen-library.com/api/',
};
